import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { FormTextField } from 'ui';

export interface ShopHeroWidgetFields extends BaseWidgetFormFields {
  leftImageUrl: string;
  leftImageAlt: string;
  rightImageUrl: string;
  rightImageAlt: string;
  bodyText: string;
  linkHref: string;
  linkText: string;
}

const URL_HELPER_TEXT =
  "Entering a comma-separated list of URLs will result in the images being looped through at a regular, short interval, producing an 'animated' effect.";

export const ShopHeroWidgetFormFields: React.FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => {
  return (
    <>
      <FormTextField
        id="leftImageUrl"
        name="leftImageUrl"
        helperText={URL_HELPER_TEXT}
        label="Left image URL"
        fullWidth
      />
      <FormTextField id="leftImageAlt" name="leftImageAlt" label="Left image alt text" fullWidth />
      <FormTextField
        id="rightImageUrl"
        name="rightImageUrl"
        helperText={URL_HELPER_TEXT}
        label="Right image URL"
        fullWidth
      />
      <FormTextField
        id="rightImageAlt"
        name="rightImageAlt"
        label="Right image alt text"
        fullWidth
      />
      <FormTextField id="bodyText" name="bodyText" label="Body text" fullWidth />
      <FormTextField id="linkHref" name="linkHref" label="Link href" fullWidth />
      <FormTextField id="linkText" name="linkText" label="Link text" fullWidth />
    </>
  );
};
